import React, { Component } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import Notice from "Components/Notice";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils.js";
import { getStore, setStore } from "Pub/js/storageUtils";
import RSAUtils from "Pub/js/security.js";
import platform from "Pub/js/platform";
const FormItem = Form.Item;
const { NCButton } = platform.base;
const Cryptograph = platform.Cryptograph;

class EmailEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prompt: false,
            num: 0,
        };
    }
    /**
     * 获取验证码
     */
    handleGetCaptcha = () => {
        const formObj = this.props.formObj;
        let { json, exponent, modulus, setValWhenGetCaptcha } = this.props;
        // let emailVale = formObj.getFieldValue("email");
        // let RSAkey = RSAUtils.getKeyPair(exponent, "", modulus);
        const cipher = new Cryptograph({});
        let RSAkey = cipher.getAsyncPublicKey();
        formObj.validateFields(["pw", "email"], (error, values) => {
            // console.log(error, values);
            if (!error) {
                if (this.state.num > 0) {
                    return;
                }
                if (this.state.num == 0) {
                    Ajax({
                        toastContainer: this.props.pageRef,
                        url: `/nccloud/platform/email/sendcaptcha.do`,
                        data: {
                            email: values.email,
                            // password: RSAUtils.encryptedString(RSAkey, values.pw),
                            password: cipher.asymmetricEncrypt(values.pw, RSAkey),
                        },
                        info: {
                            name: langCheck('UserInfo-000006', 'pages', json), /* 国际化处理： 发送验证码*/
                            action: langCheck('UserInfo-000006', 'pages', json), /* 国际化处理： 发送验证码*/
                        },
                        loading: true,
                        success: ({ data: { data } }) => {
                            if (data.status) {
                                setValWhenGetCaptcha(values.email); //发送验证码时的邮箱要和提交的邮箱保持一致
                                this.setState(
                                    {
                                        prompt: true,
                                        num: 60,
                                    },
                                    this.captchaCount,
                                );
                            }
                            Notice({
                                status: data.status ? "success" : "error",
                                msg: data.msg,
                                container: this.props.pageRef
                            });
                        },
                    });
                }
            }
        });
    };
    /**
     * 验证码计数
     */
    captchaCount = () => {
        let fun = () => {
            let num = this.state.num;
            if (num === 0) {
                this.setState({ prompt: false });
                clearInterval(timer);
            } else {
                num--;
            }
            this.setState({ num });
        };
        let timer = setInterval(fun, 1000);
    };

    checkEmail = async (rule, value, callback) => { 
        let { json, email, infoType } = this.props;
        let STOREFORINFODATA = getStore("STOREFORINFODATA");
        email = infoType=='2' ? STOREFORINFODATA.email: email; //'2'是用户，否则取传来的人员邮箱
        if (value == email) {
            throw new Error(langCheck('UserInfo-000057', 'pages', json)); //修改邮箱不能和原邮箱一样
        }
    }
    render() {
        let { layout, formObj, json } = this.props;
        let { getFieldDecorator } = formObj;

        return (
            <Form>
                <FormItem
                    className="userinfo-item"
                    {...layout}
                    colon={false}
                    label={langCheck('UserInfo-000007', 'pages', json)}/* 国际化处理： 密码*/
                >
                    {getFieldDecorator("pw", {
                        rules: [
                            {
                                required: true,
                                message: langCheck('UserInfo-000008', 'pages', json), /* 国际化处理： 请输入密码！*/
                            },
                        ],
                    })(<Input type="password" autocomplete="new-password" fieldid="password" />)}
                </FormItem>
                <FormItem
                    className="userinfo-item"
                    {...layout}
                    colon={false}
                    label="E-mail"
                >
                    {getFieldDecorator("email", {
                        rules: [
                            {
                                type: "email",
                                message: langCheck('UserInfo-000009', 'pages', json), /* 国际化处理： 输入不是有效的电子邮箱！*/
                            },
                            {
                                required: true,
                                message: langCheck('UserInfo-000010', 'pages', json), /* 国际化处理： 请输入电子邮箱!*/
                            },
                            { validator: this.checkEmail },

                        ],
                    })(<Input fieldid="email" />)}
                </FormItem>
                <FormItem
                    className="userinfo-item"
                    {...layout}
                    colon={false}
                    label={langCheck('UserInfo-000011', 'pages', json)}/* 国际化处理： 验证码*/
                    extra={
                        this.state.prompt
                            ? langCheck('UserInfo-000012', 'pages', json)/* 国际化处理： 验证码已发送至您的电子邮箱，请注意查收！*/
                            : ""
                    }
                >
                    <Row gutter={8}>
                        <Col span={12}>
                            {getFieldDecorator("captcha", {
                                rules: [
                                    { required: true, message: langCheck('UserInfo-000013', 'pages', json) }, /* 国际化处理： 请输入验证码!*/
                                ],
                            })(<Input fieldid="captcha" />)}
                        </Col>
                        <Col span={12}>
                            <NCButton
                                colors="primary"
                                className="captcha-btn"
                                onClick={this.handleGetCaptcha}
                                fieldid="captcha"
                            >
                                {langCheck('UserInfo-000014', 'pages', json)/* 国际化处理： 获取验证码*/}
                                {this.state.num > 0
                                    ? `(${this.state.num})`
                                    : ""}
                            </NCButton>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}
export default EmailEdit;
